module.exports = __webpack_public_path__ + "static/media/sellinghistory.2b4de77e.svg";